import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, SearchField } from '@frontend/design-system';
import { useListBoxContext } from '../list-box-context';

type Props = {
  onClose: () => void;
};

export const DefaultViewHeader = ({ onClose }: Props) => {
  const { searchFieldProps } = useListBoxContext();

  return (
    <header css={headerStyles}>
      <div css={headerLeftStyles}>
        {searchFieldProps && <SearchField name='search' {...searchFieldProps} clearable={false} />}
      </div>
      <Button iconName='x' variant='secondary' onClick={onClose} />
    </header>
  );
};

const headerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1.5, 2),
});

const headerLeftStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  width: '100%',

  '& > div': {
    width: '100%',
  },
});
